import {
  access_code,
  merchant_identifier,
  signature_key,
  signature_url,
} from "../../../config";
import log from "../../../utils/log";

export default async function payfortSignatureAsync(params) {
  log("payfortSignatureAsync", "request", params);

  const baseUrl = signature_url;

  // constant values
  params.command = "PURCHASE";
  params.access_code = access_code;
  params.merchant_identifier = merchant_identifier;
  params.currency = "SAR";
  params.amount *= 100;

  const keys = Object.keys(params);
  let x = "";
  keys.forEach((key) => {
    if (x.length > 0) x += "&";
    x += `${key}=${params[key]}`;
  });

  const uri = baseUrl + `?${x}`;
  const encoded = encodeURI(uri);

  const response = await fetch(encoded, {
    headers: {
      "x-functions-key": signature_key,
    },
  });

  if (response.status === 200) {
    const json = await response.json();
    log("payfortSignatureAsync", "response", json);

    return json;
  }

  throw new Error(response.status);
}
